var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#42C1CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96175 7.26079C9.171 6.3816 9.423 5.59129 9.69075 5.07548C9.78919 4.8291 10.1886 4.23904 10.6268 3.84923C11.3563 3.19954 12.1748 3.03473 13.0269 3.56966C13.4618 3.84248 13.6361 4.12316 13.5596 4.38754C13.5034 4.58441 13.2879 4.74191 13.1726 4.7256C13.0039 4.74248 12.834 4.70873 12.672 4.58948C12.5356 4.48443 12.4304 4.34423 12.3677 4.18391C12.2484 3.90266 12.0921 3.80704 11.9003 3.82954C11.7613 3.84529 11.5999 3.93416 11.5487 3.99379L11.4165 4.14004C11.3138 4.24946 11.2225 4.36915 11.1443 4.49723C10.8765 4.94329 10.6296 5.7606 10.287 7.45429L12.5573 7.78673L12.4324 8.69629L10.1284 8.35879L10.0299 8.95729L10.0046 9.10691C9.99113 9.18454 9.9765 9.26891 9.95963 9.35891L12.2861 9.69979L12.1528 10.6082L9.77175 10.2595C9.49669 11.4284 9.13444 12.681 8.8785 13.1755C8.7795 13.4224 8.38069 14.0114 7.9425 14.4017C7.21294 15.0509 6.3945 15.2162 5.54231 14.6813C5.1075 14.4085 4.93313 14.1272 5.00963 13.8629C5.06588 13.666 5.28131 13.509 5.39663 13.5254C5.56538 13.5085 5.73525 13.5422 5.89725 13.6609C6.02213 13.7532 6.12563 13.887 6.20156 14.067C6.32081 14.3477 6.47719 14.4439 6.669 14.4214C6.80794 14.4051 6.96938 14.3162 7.02056 14.2566C7.53075 13.6885 7.93519 12.5939 8.4465 10.066L6.17625 9.73298L6.30113 8.82341L8.60513 9.16091L8.70413 8.56298C8.726 8.42865 8.74944 8.29457 8.77444 8.16079L6.45694 7.8216L6.58969 6.91316L8.96175 7.26079Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFil);
export default __webpack_public_path__ + "static/media/fil.2c4804043cacaa19767b7490eca14f43.svg";
export { ForwardRef as ReactComponent };